const LOGO_SIZE_RECORD = {
  combination: {
    small: {
      width: 67,
      height: 20
    },
    medium: {
      width: 94,
      height: 28
    },
    large: {
      width: 133,
      height: 40
    }
  },
  symbol: {
    small: {
      width: 20,
      height: 20
    },
    medium: {
      width: 28,
      height: 28
    },
    large: {
      width: 40,
      height: 40
    }
  },
  text: {
    small: {
      width: 41,
      height: 19
    },
    medium: {
      width: 57,
      height: 26
    },
    large: {
      width: 81,
      height: 37
    }
  }
};
function useLogoSize(params) {
  const { size, variant } = params;
  return LOGO_SIZE_RECORD[variant][size];
}

export { useLogoSize };
//# sourceMappingURL=useLogoSize.mjs.map
